import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined'
import { RadioGroup as MuiRadioGroup, Radio, Box, Typography, Tooltip, type RadioGroupProps as MuiRadioGroupProps } from '@mui/material'
import FormControl from '@mui/material/FormControl'
import FormControlLabel from '@mui/material/FormControlLabel'
import { forwardRef, type ForwardedRef } from 'react'
import { AsteriskRed } from '../AsteriskRed/AsteriskRed'
import { HStack } from '../HStack/HStack'
import { VStack } from '../VStack/VStack'
export interface RadioGroupProps extends Omit<MuiRadioGroupProps, 'children'> {
  radioData: {
    key: string
    value: string
  }[]
  required?: boolean
  label?: string
  value: string
  noTitle?: boolean
  tooltipText?: string
  layout: 'row' | 'column'
}

export const RadioGroup = forwardRef(function RadioGroup(
  { radioData, label, required, noTitle, tooltipText, layout, ...props }: RadioGroupProps,
  ref: ForwardedRef<unknown>,
) {
  const StackComponent = layout === 'row' ? HStack : VStack
  return (
    <>
      {!noTitle && (
        <Box>
          <Typography fontSize="small">
            {label || <>&nbsp;</>}
            {required && <AsteriskRed />}
            <>&nbsp;</>
            {tooltipText && (
              <Tooltip title={tooltipText}>
                <HelpOutlineOutlinedIcon fontSize="small" />
              </Tooltip>
            )}
          </Typography>
        </Box>
      )}
      <FormControl>
        <MuiRadioGroup ref={ref} {...props}>
          <StackComponent>
            {radioData.map(({ key, value }) => (
              <FormControlLabel key={key} value={key} control={<Radio size="small" />} label={value} />
            ))}
          </StackComponent>
        </MuiRadioGroup>
      </FormControl>
    </>
  )
})
